import React from 'react';
import { OfferTagItemProps, SummaryPanel } from 'component/page/detail/DetailCard/SummaryPanel/SummaryPanel';
import ScreenSize from 'component/common/Experiment/ScreenSize';
import { Stack } from '@drone-js/core';

export interface OfferTagProps {
    offerTags: OfferTagItemProps[];
}
export const SummaryPanelContainer: React.FC<OfferTagProps> = (props) => {
    if (!props.offerTags || props.offerTags.length <= 1) {
        return null;
    }
    return (
        <>
            <ScreenSize.Desktop>
                <Stack direction="row" mb="24" width="100%">
                    {props.offerTags.map((tag, index) => (
                        <SummaryPanel key={index} tagName={tag.tagName} tagValue={tag.tagValue} isLastIndex={index === props.offerTags.length - 1} />
                    ))}
                </Stack>
            </ScreenSize.Desktop>
            <ScreenSize.NonDesktop>
                <Stack direction="column" gap="8" width="100%" mb="16">
                    {Array.from({ length: Math.ceil(props.offerTags.length / 2) }).map((_, rowIdx) => (
                        <Stack direction="row" mt={rowIdx !== 1 ? '0' : '4'} width="100%" key={rowIdx}>
                            {props.offerTags.slice(rowIdx * 2, rowIdx * 2 + 2).map((tag, colIdx) => (
                                <SummaryPanel key={colIdx} tagName={tag.tagName} tagValue={tag.tagValue} />
                            ))}
                        </Stack>
                    ))}
                </Stack>
            </ScreenSize.NonDesktop>
        </>
    );
};
SummaryPanelContainer.displayName = 'SummaryPanelContainer';
